//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

//*******************Demo pattern of objects****************
// {
//   img:
//     "https://drive.google.com/uc?export=view&id=",
//   frame: "",
//   location: ""
// },

export const compositionURLs = [
  {
    img:
      "https://drive.google.com/uc?export=view&id=1y6hzx9odSAbrg77oVIL0fFw5HUymM2AM",
    frame: "Macro lens is wide angle also",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1Uk0QHj8zk1ohalaGs0z-t3_xBj1LY-9t",
    frame: "Frame in frame",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1FXAsigVBGTXj3G68zK9JxTPJn9nA1g1l",
    frame: "Light trails",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1E45rEJCUeJ4YK1SZIVbhCS3GTyGz_OD0",
    frame: "Metal gate covered with plastic sheet",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=12njDLV6UjzaWAaxKLAgGr2PZ7z33ymh2",
    frame: "Light trails",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1NpCwSNbS5NH9Nc7kr0mHB1nfo7p-iu6B",
    frame: "Person in the mirror is meant to be closer than he appear",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=135ZK9wfsi0mqBN9smS0GzVRna4Ff6u9E",
    frame: "Roads during lockdown",
    location: "Mawana, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1l__Vbrai9kuXnty0y0EC0de3tgvY_pWt",
    frame: "Roads during lockdown",
    location: "Mawana, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=19GEAbZXbvDyN04_MRWwJa4pXmIFcGJeZ",
    frame: "Chhavi Sarda",
    location: "Lavasa, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=105q6udLy4b1mjLdtxAGjds3246LIkfTc",
    frame: "Chhavi Sarda",
    location: "Lavasa, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1LOj491yzzHKh2Ug_E0nP8z8pSMftk0t0",
    frame: "Multiplex inside campus",
    location: "Infosys Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1kIqEzncOlWLJgC6WP5WnQQF8qtJBxOg5",
    frame: "Tea",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1s4zZCCdqkEZI3DGl9yjTJ0SXii7AVxVr",
    frame: "Spider macro shot",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1O9VDAQO3lgRDChjPsqjktR1uk2MGPcOs",
    frame: "Spider macro shot",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Jw77U6M0u9o0QWnm0jjoimuVtfx-49lt",
    frame: "Frame in frame",
    location: "Mawana, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1AdmES5zDqPK1briCHNGkJkwZEjZb7ZGc",
    frame: "Multiplex and swimming area",
    location: "Infosys Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1zfXAhy2TzNWxsRyKrHiGZs_liippLg21",
    frame: "House fly macro shot",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1npHxMoguvbpJcmiKjztgQzp567CkMHTE",
    frame: "TinselTown club house",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1_cZMVHJXm9ExXup-uwxNJi_5Vva56Z7_",
    frame: "TinselTown by Kohinoor",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1PqldzgIKNOEFgQVoBL09BdVNhkQv2dVF",
    frame: "Global education center (GEC)",
    location: "Infosys Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1HQK2y8QAfjAZ8n6D6YHALy3fBnyhzIJk",
    frame: "View from flats of tinseltown by kohinoor",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13FZQEf04zM89RRnK5lpgI43ehJn07dzU",
    frame: "Multiple light reflections from Infosys Pune guest house",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11MwLEuD7N-ZK0X7sgBF7EqgB1xhnOO-A",
    frame: "Chamundi hills",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1xgefAfzRCTiHNkrITuDW0Hki-C1wQDHQ",
    frame: "Global education center, Infosys Mysore Campus",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1YmG__4PboL-JoFkVKRXgnabY1FNXa-Jv",
    frame: "Oye punjabi restaurant",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1O_YSxGJWri9TdHB5zyG9nzUKAht5vmNZ",
    frame: "View from GEC of Infosys Mysore",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1NZnEm1UPncqtCteFCoaY-zcf-vv0ih_e",
    frame: "View from GEC of Infosys Mysore",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=15lhyv4TH6tUMuzlZhBhH5UrRVAdwd1bS",
    frame: "Leaning tree in Tipu sultan palace",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12O_oA0XM7VXQI7Jh_H8VOu9qR896ubJb",
    frame: "Tipu sultan palace",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1kX7G8t5iLZSeVT2_V6JhcbGp0TXGEh8d",
    frame: "Freezed rain water droplet",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1ZVma7sjuL5wJZPdbynG1vZQAtOWx53f0",
    frame: "Freezed rain water droplet",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1AGgreDT0Fbg7kMJOWHMsAPcdu_dsLUQO",
    frame: "Freezed rain water droplet",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Q6MeB4D5fgw2g2qQvECBS3w1e5Gglgue",
    frame: "Frame in frame and division of frame",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1X_0cVslNtLfkV88SggfO_VqfJD1Khzg5",
    frame: "Minion inside shuttle during Lockdown pandemics",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1EVKfZlsO9rvmpEPEg17g9ha_Dcq9w-io",
    frame: "Frame in frame",
    location: "Mawana, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1ybn8Zdg7FFyI8tM2JKZAUUlf3nU1GSEf",
    frame: "Diffraction of light around the edges",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1UTV1FKkASlnzmiwUMym6edgm_YFacJLL",
    frame: "Diffraction of light around the edges",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1o26Il--YuE89k33L_W59HkUiJt2o9ERO",
    frame: "Sheesha smokes",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1ephk_1MfzEVUEYPVFNLNASHpxt2Cwahn",
    frame: "Sheesha smokes",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1zj6f460MqqnvUWARpZg-QBPvI7LU6xw1",
    frame: "Freezed motion",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1cWafMNyNLeHfptqCsy3nX45mtYrucnxm",
    frame: "Freezed motion",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1sONkIONjSdlVI0F7qgPkQnuBqz69G4f9",
    frame: "Light trails",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1XuLmrQxtC_9MFZ9OFZCYFtWzFfdOzoAd",
    frame: "Light trails",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1W6d7v2mkdPdKolsbKB7CPLavxFCvrVPM",
    frame: "Ganesh Idol with light trail",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=17tTi0er2NyLaxTdPTbsZ8l3Z9m9lcwUV",
    frame: "Freezed motion",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1yFvcZXI4x27PE8xwPVD9NUADlhTPN4gH",
    frame: "Soft toy in custom made frame",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1mxZBLyhKiNQZ4avzewFI88sgNEM7NZyK",
    frame: "Handstand with motion freeze",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1WsutUOwKfGUqrtwT5sXPVCz0h6BbtFwS",
    frame: "Perception",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1QiwqdApuo76VI_Bmim-aQCyz1oGesMVV",
    frame: "Perception",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=18VNWO26KNjoBS0VcS-HEI6F_LwJMWom6",
    frame: "Sheesha smoke",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1DS0QvgMbgBNQk3wUV1fu2aWjTorYroE8",
    frame: "Sheesha smoke",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1uWDadGJ-PokHi_b66CTXYc6ajkmMNMHt",
    frame: "Product photography",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1lKV319Cn8H1TlVGEn-SUM48C83MOqamB",
    frame: "Product photography",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1mLiYrqvaJP69hQXE8_6ICC57XmsMs3yt",
    frame: "Light reflections and framing",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1g9s7iU7nKGVCJACDNbAbtIqJSWBViM3h",
    frame: "Canon zoom lens in custom made frame",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1x1YpvQ99pgJ0yRsKFG8rwIzoM_21tuNn",
    frame: "Cigarette and ashes",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1cqXWNpBOCSBFXCqouL_u41xYp0JGg0zk",
    frame: "Cigarette and ashes",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1X9Ctpww5zmXu-KFavX-Zf6MKenjiV8Qi",
    frame: "Cigarette and ashes",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1kyKWcxvBbIIe64zICL8G6TK93SX_PMP_",
    frame: "Sunset reflection on a phone",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1b8rWZjg4Jrsz4VYswkcUY8aSer2u-aWW",
    frame: "Still frame and subjects",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1S56Rs5Wjs-AGDLTa-ivqG5MVb3BOhwbD",
    frame: "Custom made remote shutter from salvaged parts",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1w5_WGXZRHpak7OKQW1VYL8bRfJsxQ3x0",
    frame: "Loose wire at beach used as a prop",
    location: "Lavasa, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1LCu-QnXGaSg39sNRzSeiAo2Anqi7WHaM",
    frame: "Loose wire at beach used as a prop",
    location: "Lavasa, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1tWzhc2hDDzcUmPswJQrgEvU15myLQSC8",
    frame: "Reflection",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1gWmS1F0fZtBE9WWXcvKlQhVA2ZnNp8Yi",
    frame: "Dragonfly",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1RDxsKhyUpCtbTbxoceS7R1dwlttoxTFm",
    frame: "Beach side",
    location: "Lavasa, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1tnoldjo52i9KAAZQxyORKous0SXwH1vE",
    frame: "Socials cafe",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1hEV13XRrz5Y2WVddhqEnodylqjF-pFh8",
    frame: "Infosys Mysore GEC",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1WbHQOG6dDFuvUxu4Oj2-4gKCTnvO3UbY",
    frame: "Chamundi hills",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1UBF7cZjqrFfJ0V-XhCgq9rX8SvJSLj23",
    frame: "Infosys mysore campus roads",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1JfmTsJix3Nz-4UwAG5A1zvXkHtyVy6vP",
    frame: "Infosys Mysore campus",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=16keD0hmTZi5OY27N0hCp5RoLJTr-A2i4",
    frame: "Sunset reflection",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10-cjur49m3UWA7htvRaRQh6P8q_CzwL7",
    frame: "Classrooms in GEC in Infosys Mysore",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1GkgEofiKs3OQymmEomlDAJ_j4Erbc0vg",
    frame: "Gas flame",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Fe4-D3nZN7qnaoSgtdThu_Nb5_9VKFwJ",
    frame: "Toy car product photogrphy from low angles",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=18rPl95jPxZZWRzWx4aHNNapqm637GMa7",
    frame: "Toy car product photogrphy from low angles",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1NbUpJqi-iAn0FsIjmC8VC0vvL-5qj-3P",
    frame: "Leading lines to moon",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1ImS18iOkNUiYNXIeTfum9F02cjPU4-DS",
    frame: "Custom made shutter remote switch",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1EJ89GK5ehTf6e2FWBuUbem2EB5y24pfu",
    frame: "Silhouette",
    location: "Lavasa, Maharashtra, India",
  },
];
